import { Popover } from 'antd';
import Calender, { DateRangeType } from 'components/molecules/Calender';
import dayjs from 'dayjs';
import { default as CalenderIcon } from 'assets/svg/Calender';
import React, { useContext, useMemo, useState } from 'react';
import { priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PSR_DATE_RANGE_CHANGED } from 'utils/mixpanelEventNames';
import { FilterContextData } from 'contexts/FilterContext';

export const DateRangePriceSimulator = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);
    const { calenderStartDay } = useContext(FilterContextData);
    const {
        viewMode,
        simulationDateRange,
        setSimulationDateRange,
        setSimulationTimePeriodSelection,
        simulationTimePeriodSelection,
        selectedDataSource,
    } = useContext(priceSimulatorDataContext);

    const handleDateChange = (range: DateRangeType) => {
        setSimulationDateRange([...range]);
    };

    //calender set date function
    const handleOpenChange = (newOpen: boolean, isClickOutside: boolean = true) => {
        selectedDataSource.value && setIsOpen(newOpen);

        if (!newOpen && !isClickOutside) {
            //only save the date when clicked on set date button
            const utcOffset = dayjs().utcOffset();
            const startDateUnix = dayjs(simulationDateRange[0]).add(utcOffset, 'm').subtract(6, 'day').unix();
            const endDateUnix = dayjs(simulationDateRange[1]).add(utcOffset, 'm').subtract(6, 'day').unix();
            setSimulationTimePeriodSelection(
                JSON.stringify({
                    start_timestamp: startDateUnix,
                    end_timestamp: endDateUnix,
                }),
            );
            trackEventMixpanel(PSR_DATE_RANGE_CHANGED, {
                startDateUnix,
                endDateUnix,
            });
        } else if (!newOpen && (!simulationTimePeriodSelection || simulationDateRange.includes(null))) {
            setSimulationDateRange([null, null]); //if clicked outside dont save the change
        }
    };

    const dateLabel = useMemo(() => {
        let startLabel = 'Start Date';
        let endLabel = 'End Date';
        if (simulationDateRange[0]) startLabel = dayjs(new Date(simulationDateRange[0])).format('MM/DD/YYYY');
        if (simulationDateRange[1]) endLabel = dayjs(new Date(simulationDateRange[1])).format('MM/DD/YYYY');
        return { startLabel, endLabel };
    }, [simulationDateRange]);
    const currentDate = new Date();

    return (
        <div className="">
            <Popover
                trigger="click"
                open={!viewMode && selectedDataSource.value && isOpen}
                onOpenChange={(open) => handleOpenChange(open)}
                placement={'right'}
                content={
                    <Calender
                        startYear={currentDate.getFullYear()}
                        disabledDates={[dayjs(currentDate).format('MM-DD-YYYY'), null]}
                        startDay={calenderStartDay}
                        range={simulationDateRange}
                        onChange={handleDateChange}
                        onFooterClick={() => handleOpenChange(false, false)}
                        maxYear={currentDate.getFullYear() + 2}
                    />
                }
            >
                <div className="flex justify-center items-center w-48">
                    <div
                        className={` ${
                            viewMode ? ' ' : 'cursor-pointer'
                        } w-full flex justify-start gap-1 py-1 items-center px-1 border border-purpleFont rounded`}
                    >
                        <div className="flex w-full justify-center">
                            <span
                                className={`${
                                    !simulationDateRange?.includes(null) && !isOpen
                                        ? 'text-subHeaderColor'
                                        : 'text-borderGrey'
                                }  font-xs`}
                            >
                                {dateLabel.startLabel}
                            </span>
                            <span
                                className={`${
                                    !simulationDateRange?.includes(null) && !isOpen
                                        ? 'text-subHeaderColor'
                                        : 'text-borderGrey'
                                } mx-1  font-xs`}
                            >
                                -
                            </span>
                            <span
                                className={`${
                                    !simulationDateRange?.includes(null) && !isOpen
                                        ? 'text-subHeaderColor'
                                        : 'text-borderGrey'
                                } font-xs`}
                            >
                                {dateLabel.endLabel}
                            </span>
                        </div>
                        <CalenderIcon />
                    </div>
                </div>
            </Popover>
        </div>
    );
};
